<template>
    <div>
    	<div>
	        <Row class="expand-row">
	        	<Table :no-data-text="$t('common.noData')" :columns="columns" :data="nodeData" style="width: 100%;"></Table>
	        </Row>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            row: Object
        },
        data () {
            return {
                columns: [
                    {
                        title: this.$t('RAM.AWS.ElasticCache.NodeID'),
                        key: 'cacheNodeId'
                    },
                    {
                        title: this.$t('RAM.AWS.ElasticCache.statusName'),
                        key: 'cacheNodeStatusName'
                    },
                    {
                        title: this.$t('RAM.AWS.ElasticCache.TerminalNode'),
                        key: 'endpointAddress'
                    },
                    {
                        title: this.$t('RAM.AWS.ElasticCache.Port'),
                        key: 'endpointPort'
                    },
                    {
                        title: this.$t('RAM.AWS.ElasticCache.AvailabilityZone'),
                        key: 'customerAvailabilityZone'
                    },
                    {
                        title: this.$t('RAM.AWS.ElasticCache.CurrentRole'),
                        key: 'cacheNodeStatusName'
                    }
                ],
                nodeData: this.row.resourceAwsCacheNodeDTOS
            }
        }
    };
</script>
<style scoped>
    .expand-row{
    	padding-left: 17px;
        margin-bottom: 10px;
    }
    .expand-key
    {
    	width: 145px;
    	display: block;
    	float: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/elasticache/ElastiCacheTableExpand.vue